export class CustomerInformation {
    public contactFirstName: string;
    public contactLastName: string;
    public contactAddress1: string;
    public contactAddress2: string;
    public contactZip: string;
    public contactCity: string;
    public contactCountry: string;
    public contactLanguage: string;
    public contactPhone1: string;
    public contactEmail: string;
    public companyName: string;
}